import { supabase } from "./supabase";
import type { HelpArticle } from "./types";

export async function fetchAllPublishedArticles(): Promise<HelpArticle[]> {
  const { data, error } = await supabase
    .from("help_articles")
    .select("*")
    .eq("is_published", true)
    .is("archived_at", null)
    .order("nav_order", { ascending: true });

  if (error) {
    throw new Error(`Failed to fetch articles: ${error.message}`);
  }
  return (data || []) as HelpArticle[];
}

export async function fetchArticleBySlug(
  slug: string
): Promise<HelpArticle | null> {
  const { data, error } = await supabase
    .from("help_articles")
    .select("*")
    .eq("slug", slug)
    .eq("is_published", true)
    .is("archived_at", null)
    .maybeSingle();

  if (error) {
    throw new Error(`Failed to fetch article: ${error.message}`);
  }
  return data as HelpArticle | null;
}

export async function fetchRedirect(oldSlug: string): Promise<string | null> {
  const { data, error } = await supabase
    .from("help_redirects")
    .select("new_slug")
    .eq("old_slug", oldSlug)
    .maybeSingle();

  if (error || !data) return null;
  return data.new_slug;
}
